import React, { useMemo } from 'react'
import { Navigate } from 'react-router-dom'

import useUser from '../../hooks/UserContext'

interface IPrivateRouteProps {
    element: any;
    shouldBeAuth: boolean;
}

const PrivateRoute: React.FC<IPrivateRouteProps> = ({ element, shouldBeAuth }) => {

    const { isLogged } = useUser()

    const privateRouteComponent = useMemo(() => {
        if (shouldBeAuth) {
            if (isLogged) {
                return element
            } else {
                return element
            }
        } else {
            if (isLogged) {
                return <Navigate replace to="/products" />
            } else {
                return element
            }
        }

    }, [isLogged, shouldBeAuth, element])

    return privateRouteComponent
}

export default PrivateRoute